export default __webpack_public_path__ + "static/media/advicegradissuegfx-07.af644484.png";